import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import PieceGestionSearchFilter from './PieceGestionSearchFilter';
import PieceGestionSearchResult from './PieceGestionSearchResult';

const styles = theme => ({
    flexContainer: {
        display: 'flex',
        flexFlow: 'column wrap'
    },
    flexItem: {
        flexGrow: '1'
    }
});

class PieceGestionSearch extends React.Component {
    render() {
        const {
            classes,
            onSelectPiece,
            onSearch,
            client, withLignes,
            namespace,
            high,
            warningReclamation,
            defautProduitInfos,
            logistiqueInfos,
            filterIMM30,
            warningLivraison,
            savInfos,
            codeDepot,
            warningCommandeLivraisonDirecte,
            defautNumeroPiece,
            cacherTableResultat,
            disableMixLignesPositivesNegatives,
            autoriserToutePieceDuJour
        } = this.props;

        return (
            <div className={classes.flexContainer}>
                <div className={classes.flexItem}>
                    <PieceGestionSearchFilter
                        client={client}
                        namespace={namespace}
                        defautNumeroPiece={defautNumeroPiece}
                        onSearch={onSearch}
                    />
                </div>
                <div className={classes.flexItem}>
                    <PieceGestionSearchResult
                        onSelectPiece={onSelectPiece}
                        withLignes={withLignes}
                        namespace={namespace}
                        high={high}
                        warningReclamation={warningReclamation}
                        defautProduitInfos={defautProduitInfos}
                        logistiqueInfos={logistiqueInfos}
                        filterIMM30={filterIMM30}
                        warningLivraison={warningLivraison}
                        savInfos={savInfos}
                        codeDepot={codeDepot}
                        warningCommandeLivraisonDirecte={warningCommandeLivraisonDirecte}
                        cacherTableResultat={cacherTableResultat}
                        disableMixLignesPositivesNegatives={disableMixLignesPositivesNegatives}
                        autoriserToutePieceDuJour={autoriserToutePieceDuJour}
                    />
                </div>
            </div>
        );
    }
}

PieceGestionSearch.propTypes = {
    namespace: PropTypes.string.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    onSearch: PropTypes.func,
    withLignes: PropTypes.bool.isRequired,
    client: PropTypes.object,
    high: PropTypes.bool,
    warningReclamation: PropTypes.bool.isRequired,
    defautProduitInfos: PropTypes.bool.isRequired,
    logistiqueInfos: PropTypes.bool.isRequired,
    filterIMM30: PropTypes.bool,
    warningLivraison: PropTypes.bool,
    savInfos: PropTypes.bool,
    codeDepot: PropTypes.string,
    defautNumeroPiece: PropTypes.string,
    warningCommandeLivraisonDirecte: PropTypes.bool,
    disableMixLignesPositivesNegatives: PropTypes.bool,

    cacherTableResultat: PropTypes.bool,

    /**
     * Si true, les pièces du jour indisponibles (DEV-4008) restent sélectionnables.
     * À utiliser dans le contexte d'une demande de changement d'adresse (DEV-4023).
     */
    autoriserToutePieceDuJour: PropTypes.bool
};

PieceGestionSearch.defaultProps = {
    warningLivraison: false,
    savInfos: false,
    warningCommandeLivraisonDirecte: false,
    disableMixLignesPositivesNegatives: false,

    cacherTableResultat: false,
    autoriserToutePieceDuJour: false
}


export default withStyles(styles)(PieceGestionSearch);